<template>
    <div>
        <v-toolbar flat dense app color="primary" dark>
            <v-toolbar-side-icon @click.stop="drawer()"></v-toolbar-side-icon>
            <v-toolbar-title>Registrar</v-toolbar-title>
        </v-toolbar>

        <v-list v-if="caixa">
            <v-list-tile>
                <v-list-tile-content>
                    <v-list-tile-sub-title>MAC</v-list-tile-sub-title>
                    <v-list-tile-title>{{caixa.mac}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>

            <v-list-tile >
                <v-list-tile-content>
                    <v-list-tile-sub-title>SLOT / PON</v-list-tile-sub-title>
                    <v-list-tile-title>PON: {{ caixa.pon }} SLOT: {{ caixa.slot }}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>

            <v-divider></v-divider>
        </v-list>

        <v-layout row grid-list-md v-if="caixa">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>FABRICANTE</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="all_fabricantes"
                        v-model="caixa.fabricante"
                        item-text="nome"
                        item-value="nome"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row grid-list-md v-if="caixa">
            <v-flex xs12 pa-3>
                <v-list-tile-sub-title>PAC PON</v-list-tile-sub-title>
                <v-select
                        hide-details
                        :items="all_caixas"
                        v-model="caixa._id"
                        item-text="nome"
                        item-value="_id"
                        single-line
                ></v-select>
            </v-flex>
        </v-layout>

        <v-layout row v-if="caixa">
            <v-flex xs12 pa-3>
                <v-btn block small color="primary" :disabled="!caixa._id || !caixa.fabricante" @click.native="add">
                    ATIVAR ONU
                </v-btn>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import { Caixas } from "../../class/caixas"
    import { EventBus } from "../../utils/event-bus.js"

    export default {
        name: "Registrar",
        data () {
            return {
                search_text: null,
                iconClass: "white--text",
                search: false,
                all_fabricantes: [
                    {
                        nome: "INTELBRAS"
                    },
                    {
                        nome: "OUTROS"
                    }
                ],
                all_caixas: [],
                caixa: null
            }
        },
        beforeMount () {
            if (this.$route.params.mac) {
                this.load(this.$route.params.mac)
            }
        },
        methods: {
            load (mac) {
                Caixas
                    .unregistered()
                    .then(ordens => {
                        let caixas = ordens.data.onus;
                        caixas.forEach((c) => {
                            if (c.mac === mac) {
                                this.caixa = c;
                                this.loadCaixasByPon(1, c.pon);
                            }
                        })
                    })
                    .catch((err) => console.error(err))
            },
            loadCaixasByPon (slot, numero) {
                Caixas
                    .allCaixasByPon(slot, numero)
                    .then(res => {
                        this.all_caixas = res.data;
                    })
                    .catch((err) => console.error(err))
            },
            add () {
                Caixas
                    .registrar(this.caixa)
                    .then(res => this.goTo())
                    .catch((err) => console.error(err))
            },
            drawer: () => {
                EventBus.$emit("drawer", true)
            },
            goTo () {
                this.$router.push("/onus-unregistered")
            }
        }
    }
</script>

<style scoped>

</style>
